import {VariableName} from 'components/Fields';

const TraceID = () => <VariableName />;

export default TraceID;
